import * as APIRoutes from '@mm/api-routes';
import ChatbotModel from '../model/ChatbotModel';
import AuthenticatedController from './AuthenticatedController';
import { mapBEChatbotToFEChatbot } from './ChatbotController';

export default class SampleBotController extends AuthenticatedController {
  static async getAll(): Promise<ChatbotModel[]> {
    const response = await super.get(`${APIRoutes.SAMPLE_BOTS}`);
    return response.map(mapBEChatbotToFEChatbot);
  }
}
